export const hasMissingAccessibilityText = (step) => {
  if (!step || step.steps) return false;

  const isInteractive = step.isInteractive === true;
  const accessibilityText =
    typeof step.accessibilityText === "string"
      ? step.accessibilityText.trim()
      : "";
  const getByText =
    typeof step.locators?.getByText?.text === "string"
      ? step.locators.getByText.text.trim()
      : "";
  const isNavigationType =
    (typeof step.type === "string" &&
      step.type.trim().toLowerCase() === "navigation") ||
    (typeof step.properties?.actionType === "string" &&
      step.properties.actionType.trim().toLowerCase() === "navigation");

  return (
    isInteractive &&
    accessibilityText.length === 0 &&
    getByText.length === 0 &&
    !isNavigationType
  );
};
